import { render, staticRenderFns } from "./ScoreConfig.vue?vue&type=template&id=f78cfb68&scoped=true"
import script from "./ScoreConfig.vue?vue&type=script&lang=js"
export * from "./ScoreConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78cfb68",
  null
  
)

export default component.exports